module.exports = __webpack_public_path__ + "static/media/Bahnschrift.133bf7a8.woff2";